import { defineStore } from 'pinia';
import { ExternalIdListItem } from '@/models/external-id-list/external-id-list-item.model';
import { api } from '@/services/http.service';
import { showErrorNotification } from '@/utils/show-notification.util';
import { ExternalIdListFilter } from '@/models/external-id-list/external-id-list-filter.model';

interface TagExternalIdListState {
  tagExternalIdList: ExternalIdListItem[];
  isTagExternalListLoading: boolean;
}

export const useTagExternalIdListStore = defineStore('TagExternalListStore', {
  state: (): TagExternalIdListState => ({
    tagExternalIdList: [],
    isTagExternalListLoading: false,
  }),
  actions: {
    setTagExternalListLoading(isLoading: boolean): void {
      this.isTagExternalListLoading = isLoading;
    },
    getTagExternalList(filterList: ExternalIdListFilter = {}): Promise<ExternalIdListItem[]> {
      this.setTagExternalListLoading(true);

      return api.tagExternal.getTagExternalIdListRequest.perform({ filterList })
        .then((data: ExternalIdListItem[]) => {
          this.tagExternalIdList = data;

          return data;
        })
        .catch((error) => {
          showErrorNotification(error);

          return [];
        })
        .finally(() => {
          this.setTagExternalListLoading(false);
        });
    },
  },
});
